import { createApiClient } from '@/lib/apiClient'

import type { AddUserToGroupApiService } from './services/addUserToGroup'
import createAddUserToGroupApiService from './services/addUserToGroup'
import type { NegotiateApiService } from './services/negotiate'
import createNegotiateApiService from './services/negotiate'
import type { RemoveUserFromGroupApiService } from './services/removeUserFromGroup'
import createRemoveUserFromGroupApiService from './services/removeUserFromGroup'

interface CreateApiServiceArgs {
  userId: string
  customerId: string
}

interface SignalRApiService {
  addUserToGroup: AddUserToGroupApiService
  removeUserFromGroup: RemoveUserFromGroupApiService
  negotiate: NegotiateApiService
}

const createSignalRApiService = ({
  userId,
  customerId,
}: CreateApiServiceArgs): SignalRApiService => {
  const apiClient = createApiClient('SignalR', {
    baseURL: `${import.meta.env.VITE_SIGNAL_R}/`,
    headers: {
      'x-functions-key': `${import.meta.env.VITE_SIGNAL_R_KEY}`,
      'x-ms-signalr-userid': userId || '',
      'x-ms-signalr-hub': `hub_${(customerId || '').split('-').join('_')}`,
    },
  })

  return {
    addUserToGroup: createAddUserToGroupApiService(apiClient),
    removeUserFromGroup: createRemoveUserFromGroupApiService(apiClient),
    negotiate: createNegotiateApiService(apiClient),
  }
}

export default createSignalRApiService
